import { DateTime } from 'luxon';

export function getDefaultLiveSessionConfig(now = DateTime.now()) {
  const easternNow = now.setZone('America/New_York');
  const minutes = easternNow.hour * 60 + easternNow.minute;
  const openMinutes = 9 * 60 + 30;
  const closeMinutes = 16 * 60;

  if (minutes < openMinutes) {
    return {
      startPeriod: 'premarket',
      startHour: 8,
      startMin: 0,
    };
  }

  if (minutes >= closeMinutes) {
    return {
      startPeriod: 'postmarket',
      startHour: 16,
      startMin: 0,
    };
  }

  return {
    startPeriod: 'open',
    startHour: 9,
    startMin: 30,
  };
}
